export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'c0297116-969a-4994-8a8e-0c46c9e4e914';
export const MODAL_CLOSE_SEC = 2.5;
